<form class="login" [formGroup]="setPasswordFormGroup">
  <div class="password-set">
    <h2>Set New Password</h2>
    <div class="password-set__container">
      <ng-container *ngIf="!isSuccess">
        <div>
          <mat-form-field>
            <mat-label>Enter new Password</mat-label>
            <input matInput [formControl]="password" id="password" type="password" />
            @if (password.hasError('required')) {
              <mat-error>Required</mat-error>
            }
          </mat-form-field>
        </div>
        <div>
          <mat-form-field>
            <mat-label>Confirm new Password</mat-label>
            <input matInput [formControl]="confirmPassword" id="confirmPassword" type="password" />
            @if (confirmPassword.hasError('required')) {
              <mat-error>Required</mat-error>
            }
          </mat-form-field>
        </div>

        <div class="password-set__error">
          @if (password.hasError('pattern')) {
            <mat-error>
              The password must: <br />
              a) be at least 7 characters in length <br />
              a) include at least 1 number <br />
              b) include at least 1 of the following special characters: # ? ! &#64; $ % ^ & * - <br />
              Note that other special characters do not work</mat-error
            >
          } @else if (setPasswordFormGroup.hasError('passwordsNotEqual')) {
            <mat-error>The passwords must match</mat-error>
          }
        </div>

        <div class="password-set__buttons">
          <button mat-raised-button class="password-set__buttons-set" (click)="setNewPassword()">SET NEW PASSWORD</button>
        </div>
        <p *ngIf="showErrorMessage" class="password-set__error-message">
          <br />
          <span [innerHTML]="errorMessage"></span>
          @if (showRequestPasswordReset) {
            <br />If this problem persits, please use the button below to request a new reset link.
            <div class="password-set__buttons">
              <button mat-raised-button class="password-set__buttons-set" (click)="requestPasswordReset()">REQUEST PASSWORD RESET</button>
            </div>
          }
        </p>
      </ng-container>
      <ng-container *ngIf="isSuccess">
        <p>Password reset successfully.</p>
        <div>
          <button mat-raised-button (click)="startLogin()">Return to Log In</button>
        </div>
      </ng-container>
    </div>
  </div>
</form>
